import {customElement, bindable} from "aurelia-framework";
import {AbstractCell} from './abstract-cell';

import './color.less';

@customElement('sio-cell-color')
export class Color extends AbstractCell
{
    @bindable column;
    @bindable item;

    itemChanged()
    {
        this.bind();
    }
}
